<template>
  <CCard>
    <CCardHeader class="font-weight-bolder">
      <CRow>
        <CCol>
          {{ $t('settings.twoWay.newConfiguration.fallback.header') }}
        </CCol>
        <CCol class="text-right text-gray-500">
          <span @click="showHelpArea = !showHelpArea">
            <CIcon
              style="cursor: pointer"
              name="question"
              size="custom-size"
              :height="20"
              viewBox="0 0 32 32"
              v-c-tooltip="{
                content: $t('settings.twoWay.newConfiguration.fallback.help.tooltip'),
                placement: 'botton',
              }"
            />
          </span>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <CCollapse class="" :show="showHelpArea">
        <CAlert color="info" class="px-5">
          {{ $t('settings.twoWay.newConfiguration.list.fallback.info') }}
        </CAlert>
      </CCollapse>
      <div>
        <label class="label-custom">
          {{ $t('settings.twoWay.newConfiguration.fallback.label.activation') }}
        </label>
        <CSwitch
          color="primary"
          shape="pill"
          class="ml-3 pt-2"
          :disabled="isEnded || loading"
          :checked="checkFallback"
          @update:checked="changeFallbackConfiguration"
        />
      </div>
      <div v-if="hasFallbackConfigured">
        <CRow class="mt-2">
          <CCol md="4">
            <div>
              <label class="label-custom">
                {{ $t('settings.twoWay.newConfiguration.fallback.label.endpoint') }}
              </label>
              <CInput v-model="fallbackData.webhooksUrl" readonly />
            </div>
          </CCol>
          <CCol>
            <label class="label-custom">
              {{ $t('settings.twoWay.newConfiguration.fallback.label.response') }}
            </label>
            <CTextarea v-model="fallbackResponse" readonly />
          </CCol>
        </CRow>
        <div class="mt-2 text-right">
          <CButton color="primary" :disable="loading" class="px-5" variant="outline" @click="handlerEdit">
            <CIcon name="cilPencil" size="custom-size" :height="14" viewBox="0 0 32 32" />
            {{ $t('settings.twoWay.newConfiguration.fallback.button.edit') }}
          </CButton>
        </div>
      </div>
    </CCardBody>
    <CModal :show.sync="showRemoveFallbackModal" :closeOnBackdrop="false">
      <template #header-wrapper>
        <h5 class="pb-5">{{ $t('settings.twoWay.newConfiguration.fallback.modal.cancelHeader') }}</h5>
      </template>
      <template #body-wrapper>
        <div class="">{{ $t('settings.twoWay.newConfiguration.fallback.modal.cancelTitle') }}</div>
      </template>
      <template #footer-wrapper>
        <div class="mt-5 text-right">
          <CButton color="white" class="px-4 mr-2" @click="cancelDeleteFallback">
            {{ $t('settings.twoWay.newConfiguration.keyword-delete.button.cancel') }}
          </CButton>
          <CButton color="primary" class="px-4" @click="deleteFallback">
            {{ $t('settings.twoWay.newConfiguration.keyword-delete.button.confirm') }}
          </CButton>
        </div>
      </template>
    </CModal>
  </CCard>
</template>
<script>
import services from '@/services.js'

export default {
  name: 'FallbackConfiguration',
  props: {
    organizationAccessNumberId: {
      type: String,
    },
    keywordsList: {
      type: Array,
      default: () => [],
    },
    isEnded: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      showHelpArea: false,
      showRemoveFallbackModal: false,
      loading: false,
      checkFallback: false,
    }
  },
  mounted() {
    this.checkFallback = this.hasFallbackConfigured
  },
  computed: {
    hasFallbackConfigured() {
      return this.keywordsList.some((el) => el.isDefault)
    },
    fallbackData() {
      return this.keywordsList.find((el) => el.isDefault)
    },
    fallbackResponse() {
      const [response] = this.fallbackData.automaticResponses
      return response?.text
    },
  },
  methods: {
    handlerEdit() {
      this.$emit('edit-fallback', this.fallbackData.id)
    },
    changeFallbackConfiguration(value) {
      this.checkFallback = value
      if (value) {
        this.createFallback()
      } else {
        this.showRemoveFallbackModal = true
      }
    },
    cancelDeleteFallback() {
      console.log('checkFallback', this.checkFallback)
      this.checkFallback = !this.checkFallback
      this.showRemoveFallbackModal = false
    },
    deleteFallback() {
      this.$emit('remove-fallback', this.fallbackData.id)
      this.showRemoveFallbackModal = true
    },

    createFallback() {
      const organizationId = this.$route.params.organizationId
      this.loading = true

      const body = {
        name: '',
        isDefault: true,
        isWildcard: true,
        hasResponseMessage: false,
        responseMessage: null,
        hasEndpoint: false,
        endpoint: null,
        isOptOut: false, // COMPORTAMENTO DEIXADO POR PADRAO EM VIRTUDE DE EVITAR A CRIAÇAO DE BEHAVIORS NO BACKEND
        isOptIn: false,
      }

      services
        .createTwoWayNewKeyword(organizationId, this.organizationAccessNumberId, body)
        .then(() => {
          const message = {
            status: 'success',
            text: this.$t('settings.twoWay.newConfiguration.fallback.create-success'),
          }

          this.$emit('creation-success', message)
        })
        .catch(({ response }) => {
          const message = {
            status: 'danger',
            text: response.data.message,
          }
          this.$emit('creation-error', message)
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
<style lang="scss">
.c-switch-slider {
  background-color: $primary;
}
</style>
